import config from "../../../../config/config";
import axios from "axios";

export const Update_Email = config.baseUrl + "auth/updateUserProfile";
export const Get_User_Profile = config.baseUrl + "auth/getUserProfile";
export const Get_User_Transactions =
  config.baseUrl + "travel/user/getUserTransaction";
export const Create_Fav_User = config.baseUrl + "ticket/favoritePassenger/";
export const Get_User_Travels =
  config.baseUrl + "travel/user/getUserActiveTravel";
export const Get_All_Fav_Passengers =
  config.baseUrl + "ticket/favoritePassenger";
export const Update_Fav_Passenger =
  config.baseUrl + "ticket/favoritePassenger/";
export const Delete_Fav_Passenger =
  config.baseUrl + "ticket/favoritePassenger/";
export const Get_All_Support_Items =
  config.baseUrl + "travel/support/getSupportItems";
export const Get_All_Support_Tickets =
  config.baseUrl + "travel/support/getSupportItemTicket";
export const Create_Support_Ticket =
  config.baseUrl + "travel/support/createSupportItemTicket";
export const Get_User_Travels_Report =
  config.baseUrl + "travel/user/userTravelReport";
export const Get_User_Credit = config.baseUrl + "auth/getUserCredit";
export const Set_Extradition = config.baseUrl + "ticket/refund";
// export const COMPLTE_TICKET_DETAILS = config.baseUrl + "ticketDetails";

export const setExtradition = (data, token) => {
  return axios.post(Set_Extradition, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateUserInfo = (data, token) => {
  return axios.put(Update_Email, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getUserProfile = (token) => {
  return axios.get(Get_User_Profile, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getUserCredit = (token) => {
  return axios.get(Get_User_Credit, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getUserTransaction = (token, params) => {
  return axios.get(Get_User_Transactions, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
};

export const getUserTravels = (token) => {
  return axios.get(Get_User_Travels, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getUserFavPassengers = (token) => {
  return axios.get(Get_All_Fav_Passengers, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createFavPassenger = (token, data) => {
  console.log("token", token);
  return axios.post(Create_Fav_User, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateFavPassenger = (token, data, id) => {
  return axios.put(Update_Fav_Passenger + id, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const deleteFavPassenger = (token, id) => {
  return axios.delete(Delete_Fav_Passenger + id, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getAllSupportTickets = (token) => {
  return axios.get(Get_All_Support_Tickets, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getAllSupportItems = (token) => {
  return axios.get(Get_All_Support_Items, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createSupportTicket = (token, data) => {
  return axios.post(Create_Support_Ticket, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getUserTravelInfo = (token, params) => {
  return axios.get(Get_User_Travels_Report, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });
};


// export const completeTicketDetails = (token, travelTicketId) => {
//   return axios.get(COMPLTE_TICKET_DETAILS, {
//     headers: { Authorization: `Bearer ${token}` },
//     params: { travelTicketId },
//   });
// };
